import {
  Box,
  Button,
  Flex,
  Input,
  HStack,
  SimpleGrid,
  Center,
  Text,
  Checkbox,
  Link
} from '@chakra-ui/react';
import Image from 'next/image';
import { Video } from 'cloudinary-react';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { ForgotPasswordMutation } from '../graphql/mutations';

import { Mixpanel } from '../utils/mixpanel';

import FormInput from '../components/Commons/FormInput';

export default function ForgotPassword() {
  const router = useRouter();

  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [oups, setOups] = useState(false);

  const [forgotPassword, { data, loading, error }] = useMutation(ForgotPasswordMutation, {
    onCompleted(data) {
      if (data?.reset_password?.response === 'success') {
        setEmailSent(true);
      } else {
        setOups(true);
      }
    }
  });

  return (
    <SimpleGrid columns={2} h="100vh" display={{ base: 'block', md: 'grid' }}>
      <Center w="100%" h="100%">
        <Box>
          <Box mb={12}>
            <Image src={'/images/docent-logo.svg'} alt="Docent" width={175} height={45} />
          </Box>

          {emailSent ? (
            <Text mt={20} fontSize="xl" maxWidth="300px">
              An email has been sent to {email} with instructions on how to reset your password.
            </Text>
          ) : (
            <>
              <Text mb={12} fontSize="xl">
                Forgot your password?
              </Text>
              <Flex direction="column">
                <FormInput
                  name="email"
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                  handleChange={(e) => setEmail(e.target.value)}
                  error={error}
                />

                {error?.graphQLErrors?.length > 0 &&
                  error.graphQLErrors.map(({ message }) => {
                    if (message.includes('phone_number')) {
                      return (
                        <Text color="red" mt={2} maxWidth="300px">
                          {JSON.parse(message)['phone_number'][0]}
                        </Text>
                      );
                    }
                  })}

                {((error && !error.graphQLErrors) || oups) && (
                  <Text color="red">Something went wrong. Please try again.</Text>
                )}

                <Button
                  disabled={!email}
                  variant="docentPrimary"
                  width="300px"
                  mt="10"
                  isLoading={loading}
                  onClick={(e) => {
                    e.preventDefault();
                    forgotPassword({
                      variables: {
                        email
                      }
                    });
                  }}>
                  Reset Password
                </Button>
              </Flex>
            </>
          )}
        </Box>
      </Center>
      <Center w="100%" h="100%" bg="black" display={{ base: 'none', md: 'inherit' }}>
        <Video
          playsInline
          secure={true}
          cloudName="docent-art"
          publicId="v1632495189/website/circle_y7gtgd"
          loop={true}
          autoPlay={true}></Video>
      </Center>
    </SimpleGrid>
  );
}
